import {Image as ImageObject, Image, Product, Variant} from "../../models/product";
import {Component, h} from "preact";
import styles from './style.module.scss';
import {connect} from "redux-zero/preact";
import {i18nService} from "../../services/i18n-service";
import {productService} from "../../services/product-service";
import ProductImage from "../product-image";

interface Props {
  variant: Variant;
  product: Product;
  onClickCallback?: (image?: ImageObject) => void
}

interface State {
  activeImageIndex: number;
}

class ImageGallery extends Component<Props, State> {

  state: State = {activeImageIndex: 0};
  observer: IntersectionObserver;

  constructor() {
    super();
    this.observer = new IntersectionObserver(this.onIntersection, {threshold: 0.5});
  }

  componentDidMount() {
    this.handleOnClick = this.handleOnClick.bind(this);
    const productImages = document.querySelectorAll('#image-carousel-container li');
    productImages.forEach(article => this.observer?.observe(article as Element));
  }

  componentDidUpdate(previousProps: Readonly<Props>, previousState: Readonly<State>, snapshot: any) {
    if (this.props.variant.productId !== previousProps.variant.productId || this.props.variant.id !== previousProps.variant.id) {
      const productImages = document.querySelectorAll('#image-carousel-container li');
      productImages.forEach(article => this.observer?.observe(article as Element));
    }
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  private onIntersection = (entries: IntersectionObserverEntry[]) => {
    const entry = entries.find(it => it.isIntersecting && it.intersectionRatio >= 0.5);
    if (entry) {
      this.setState({activeImageIndex: parseInt(entry.target.getAttribute('data-index'))});
    }
  }

  private handleOnClick(image: Image) {
    if (this.props && this.props.onClickCallback) {
      this.props.onClickCallback(image);
    }
  }

  render(props: Readonly<Props>, state: Readonly<State>) {
    return (<>
        <div id={'detail-images-scroll-container'}
             class={`${styles.images} image-scroll-snap-container`}>
          <ol id={'image-carousel-container'} class={styles['image-carousel-container']}>
            {this.props.variant.images.map((image: Image, index: number) => {
              return (<li data-index={index} id={`image-${index}`} class={styles.image}
                          onClick={() => this.handleOnClick(image)}>
                <ProductImage scrollContainer={'#detail-images-scroll-container'} image={image}
                              alt={i18nService.translate(productService.getTranslationKey(this.props.product))}
                              resolution={image.type === 'CUTOUT' ? 'mid' : 'full-hd'}/>
              </li>);
            })}
          </ol>
        </div>
        {this.props.variant.images.length > 1 ? <div class={styles['slider']}>
          <div id={'scrollbar-thumb'} class={styles['scrollbar-thumb']}>
            {this.props.variant.images.map((image, index) =>
              <span class={this.state.activeImageIndex >= index ? styles['active'] : ''}
                    style={`width: ${document.querySelector('#detail-images-scroll-container')?.clientWidth / this.props.variant.images.length}px`}></span>)}
          </div>
        </div> : <></>}
      </>
    )
  }
}

export default connect(null, null)(ImageGallery)